import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d1e737c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sent"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Naam:", -1))
const _hoisted_4 = {
  ref: "name",
  type: "text",
  id: "name"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mail" }, "E-mailadres:", -1))
const _hoisted_6 = {
  ref: "mail",
  type: "text",
  id: "mail"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Bericht:", -1))
const _hoisted_8 = {
  ref: "message",
  id: "message"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onclick"]
const _hoisted_12 = ["onclick"]
const _hoisted_13 = { key: 3 }
const _hoisted_14 = ["onclick"]
const _hoisted_15 = ["onclick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_success_alert = _resolveComponent("success-alert")!
  const _component_error_alert = _resolveComponent("error-alert")!
  const _component_notice_alert = _resolveComponent("notice-alert")!

  return (_openBlock(), _createElementBlock("form", {
    ref: "form",
    class: _normalizeClass({ 'validated-input': $data.isValidated })
  }, [
    ($data.isSent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "sent", {}, undefined, true),
          _createVNode(_component_success_alert, null, {
            default: _withCtx(() => [
              _createTextVNode(" Het bericht is succesvol verzonden. ")
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "draft", {}, undefined, true),
          _hoisted_3,
          _createElementVNode("input", _hoisted_4, null, 512),
          _hoisted_5,
          _createElementVNode("input", _hoisted_6, null, 512),
          _hoisted_7,
          _createElementVNode("textarea", _hoisted_8, null, 512),
          ($data.error)
            ? (_openBlock(), _createBlock(_component_error_alert, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($data.error), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ($data.isSending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_notice_alert, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Het bericht wordt verzonden. ")
                  ]),
                  _: 1
                })
              ]))
            : ($data.isValidated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_notice_alert, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Controleer of alles naar wens is ingevuld. ")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("button", {
                    onclick: $options.edit,
                    type: "button"
                  }, " Bewerken ", 8, _hoisted_11),
                  _createElementVNode("button", {
                    onclick: $options.send,
                    type: "button"
                  }, " Verzenden ", 8, _hoisted_12)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onclick: $options.cancel,
                    type: "button"
                  }, " Annuleren ", 8, _hoisted_14),
                  _createElementVNode("button", {
                    onclick: $options.validate,
                    type: "button"
                  }, " Controleren ", 8, _hoisted_15)
                ]))
        ]))
  ], 2))
}